"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "barzano": {
    "a44202eb": [{
      "hkey": "d4e0221c",
      "slug": "barzano",
      "name": "Barzanò",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-gallo": [{
      "hkey": "d4e0221c",
      "slug": "barzano",
      "name": "Barzanò",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9ec90259": [{
      "hkey": "d4e0221c",
      "slug": "barzano",
      "name": "Barzanò",
      "primary": true,
      "skipSearch": false
    }],
    "cassinetta": [{
      "hkey": "d4e0221c",
      "slug": "barzano",
      "name": "Barzanò",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4b3224d5": [{
      "hkey": "1645a613",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-feriolo": [{
      "hkey": "1645a613",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "barzano"
    }],
    "82e75581": [{
      "hkey": "1645a613",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "torricella": [{
      "hkey": "1645a613",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "barzano"
    }]
  }
};
exports["default"] = _default;